import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=028d78cc&scoped=true"
import script from "./realTime.vue?vue&type=script&lang=js"
export * from "./realTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d78cc",
  null
  
)

export default component.exports